import { roles } from '@nxsys/store/constants';
import AutoEnrollmentStatusReport from '../../../modules/reports/pension/listing/AutoEnrollmentStatusReport';
import PensionContributionReport from '../../../modules/reports/pension/listing/PensionContributionReport';
import ContributionsReportIreland from '../../../modules/reports/pension/listing/ContributionsReportIreland';

export const pensionReportsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/pension/contribution-report',
    element: <PensionContributionReport />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/pension/auto-enrolment-status-report',
    element: <AutoEnrollmentStatusReport />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/pension/contributions-ireland',
    element: <ContributionsReportIreland />,
  },
  // {
  //   permittedRole: [roles.admin, roles.employer],
  //   path: '/reports/pension/export-pension',
  //   element: <ComingSoon />,
  // },
];
